<div class="p-6 flex flex-col gap-6 bg-lGray900 rounded-3xl">
  <div class="flex items-start justify-between">
    <div class="flex flex-col gap-1">
      <h2 class="text-xl font-bold text-color">Importar usuários</h2>
      <p class="text-sm subtext-color">Importe usuários em massa via arquivo padrão</p>
    </div>
    <button (click)="close()" class="text-lGray500 hover:text-lGray300 transition-colors p-1">
      <l-icon class="text-2xl">close</l-icon>
    </button>
  </div>

  <img
    src="assets/icons/folder.svg"
    alt="Importar usuários"
    class="h-48 m-auto w-auto object-contain"
  />

  @if (isLoading) {
    <p class="text-sm font-medium text-color">Carregando...</p>

    <div class="h-5 w-full overflow-hidden rounded-full">
      <l-loading-bar />
    </div>
  } @else {
    <div class="flex flex-col gap-3">
      <label for="import-users-file" class="text-sm font-medium text-color">Planilha</label>

      @if (!selectedFile) {
        <div
          class="flex items-center gap-3 border border-lGray950 bg-lGray950 rounded-xl px-4 py-3 cursor-pointer hover:border-lPrimary transition-colors"
          [ngClass]="{ '!border-lDanger': fileError }"
          (click)="fileInput.click()"
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
        >
          <l-icon class="subtext-color text-xl">upload_file</l-icon>
          <span class="subtext-color text-sm">Selecione um arquivo</span>
          <input
            id="import-users-file"
            #fileInput
            type="file"
            accept=".xlsx,.xls,.csv"
            class="hidden"
            (change)="onFileInputChange($event)"
          />
        </div>
      } @else {
        <div class="flex items-center gap-3 border border-lPrimary bg-lGray950 rounded-xl px-4 py-3">
          <l-icon class="text-lPrimary text-xl">description</l-icon>
          <span class="text-sm text-color flex-1 truncate">{{ selectedFile.name }}</span>
          <button
            (click)="removeFile()"
            class="text-lGray500 hover:text-lDanger transition-colors"
          >
            <l-icon class="text-xl">close</l-icon>
          </button>
        </div>
      }

      @if (fileError) {
        <small class="text-lDanger text-xs">{{ fileError }}</small>
      }

      <div class="flex gap-3">
        <button
          lButton
          [bType]="buttonTypeEnum.OUTLINE"
          [bSize]="buttonSizeEnum.FULL"
          [bRadius]="buttonRadiusEnum.BASE"
          class="hover:!bg-lPrimary hover:!border-none hover:!text-white transition-all"
          (click)="downloadTemplate()"
        >
          Arquivo template
          <l-icon class="text-lg">download</l-icon>
        </button>

        <button
          lButton
          [bType]="buttonTypeEnum.PRIMARY"
          [bSize]="buttonSizeEnum.FULL"
          [bRadius]="buttonRadiusEnum.BASE"
          (click)="fileInput2.click()"
        >
          Selecionar arquivo
          <input
            #fileInput2
            id="import-users-file-alt"
            type="file"
            accept=".xlsx,.xls,.csv"
            class="hidden"
            (change)="onFileInputChange($event)"
          />
        </button>
      </div>

      <div class="flex items-center gap-2 mt-1">
        <input
          id="update-existing"
          type="checkbox"
          class="custom-checkbox"
          [(ngModel)]="updateExisting"
        />
        <label for="update-existing" class="text-xs subtext-color cursor-pointer transition-colors hover:text-lWhite">
          Atualizar usuários existentes (Usuários já cadastrados serão atualizados na importação)
        </label>
      </div>

    </div>
  }
  
</div>

<div class="flex justify-center mt-10">
  <button
    lButton
    [bType]="isLoading || !isSubmitEnabled ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
    [bSize]="buttonSizeEnum.MEDIUM"
    [bRadius]="buttonRadiusEnum.LARGE"
    [disabled]="!isSubmitEnabled || isLoading"
    (click)="submit()"
  >Importar</button>
</div>
